<template>
	<div v-show="selfDisplay" class="screen_video">
		<transition 
			name="scale_transition"
			@before-enter="beforeEnter"
			@after-leave="afterLeave"
		>
			<div v-if="display" class="video_box">
				<div class="video_container">
					<video autoplay="autoplay" controls="controls">
						<source :src="src" type="video/mp4">
						你的浏览器不支持video标签！！！
					</video>
				</div>
				<i class="close" @click="handleCloseClick"></i>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			src: {
				type: String,
				default: ''
			}
		},
		mounted() {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return {
				selfDisplay: false
			}
		},
		methods: {
			handleCloseClick() {
				this.$emit("changeDisplay", false);
			},
			
			beforeEnter() {
				this.selfDisplay = true;
			},
			afterLeave() {
				this.selfDisplay = false;
			}
		}
	}
</script>

<style scoped>
	.screen_video{ position: fixed;z-index: 199;width: 100%;height: 100%;top: 0;left: 0;min-width: 1200px;background: rgba(0, 0, 0, 0.2); }
	.screen_video .video_box{ position: absolute;width: 820px;height: 520px;top: 50%;left: 50%;margin: -260px 0 0 -410px;border: 10px solid #fff;border-radius: 10px; }
	.screen_video .close{ display: block;position: absolute;z-index: 9;width: 32px;height: 32px;top: -57px;right: 0px;background-image: url(../../assets/close.png);background-size: cover;cursor: pointer;transition: all .3s linear; }
	.screen_video .video_container{ position: relative;height: 500px;background: #000;overflow: hidden; }
	.screen_video video{ display: block;position: absolute;top: 50%;left: 50%;width: 100%;height: 100%;transform: translate(-50%, -50%); }
	.screen_video .close:hover{ transform: rotateZ(180deg); }
</style>
